<template>
  <div>
    <el-table
      class="conf-table"
      :data="confData"
    >
      <el-table-column
        prop="confKey"
        label="键">
      </el-table-column>
      <el-table-column
        label="值">
        <template slot-scope="scope">
          <div class="val-wrap">
            <div>{{scope.row.confValue}}</div>
            <div v-if="confType == 's'">
              <el-button type="success" class="confirm-btn" @click="handleShowUpdate(scope.row.confKey, scope.row.confValue)">更新</el-button>
              <el-button type="primary" @click="refresh(scope.row.confKey,scope.$index)">刷新</el-button>
              <el-button type="danger" @click="remove(scope.row.confKey)">删除</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="update-dialog">
      <el-dialog
        title="更新"
        :visible.sync="dialogVisible"
        width="60%"
        @closed="handleClose">
        <div>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            :rows="6"
            v-model="val"
            resize="both">
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleUpdate()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import api from '../../api';
export default {
  name: 'ConfList',
  data() {
    return {
      dialogVisible: false,
      createDialogVisible: false,
      choosedKey: '',
      val: '',
      confData : [],
    };
  },
  computed: {
    ...mapState('siteConf', ['confType', 'confList'])
  },
  methods: {
    ...mapActions('siteConf', [
      'list',
      'update'
    ]),
    handleShowUpdate(k, v) {
      this.choosedKey = k;
      this.val = v;
      this.dialogVisible = true;
    },
    handleUpdate() {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.update({
            k: this.choosedKey,
            v: this.val
          }).then(() => {
            this.$message.success('操作成功！');
            this.dialogVisible = false;
            this.handleClose();
            this.$emit('refresh');
          });
        }
      );
    },
    handleClose() {
      this.choosedKey = '';
      this.val = '';
    },

    refresh(key,index) {
      api.refreshConfigByKey(key).then(response => {
        this.$set(this.confData,index,response.data);
        this.$message({ type : 'success',message : '刷新成功'});
      });
    },

    remove(key) {
      api.removeConfigByKey(key).then( () => {
        this.$message({ type : 'success',message : '删除成功'});
        this.$emit('query');
      })
    },
  },

  watch: {
    confList(val){
      this.confData = JSON.parse(JSON.stringify(val));
    },

  }
};
</script>

<style lang="less" scoped>
.conf-table {
  margin-top: 20px;
}
.confirm-btn {
  margin-top: 10px;
}
</style>
